import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="Valutazione 5 stelle su 5" data-id="element-329" data-mp="3mgiv6k51j24q">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-330" data-mp="3r8trze4hi7t2" data-mpi={index} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-12 sm:px-6 sm:py-20" data-id="element-331" data-mp="44w3ap8q837h">
      <div className="mx-auto max-w-4xl" data-id="element-332" data-mp="937astbju1mj">
        <div className="text-center" data-id="element-333" data-mp="902x95c71tj7">
          <SectionLabel data-id="element-334" data-mp="e18rj7li5ouu">Cosa dicono i medici</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-335" data-mp="dymkra6frddo">
            Perché i medici scelgono un percorso strutturato
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy/75 sm:text-lg" data-id="element-336" data-mp="1skj4id9mv1lh">
            Invece di cercare continuamente tra diverse risorse durante la visita.
          </p>
        </div>

        <ul className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-337" data-mp="1iugac9qrzhlk">
          {testimonials.map(item => <li key={item.id} className="flex flex-col rounded-2xl border border-navy-deep/10 bg-cream p-5 sm:p-6" data-id="element-338" data-mp="1etxjahwpifkf">
              <Stars data-id="element-339" data-mp="2bh14fhymy7st" />
              <blockquote className="mt-3 text-[14.5px] leading-relaxed text-navy/85" data-id="element-340" data-mp="26kk5dspwe90y">
                “{item.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-341" data-mp="22h5lgqyu98i8">
                <img src={item.photo} alt={`Foto di ${item.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-342" data-mp="1xkf665uuygxv" />
                <div data-id="element-343" data-mp="nl4eqh11d75t">
                  <p className="text-[14px] font-extrabold leading-tight text-navy-deep" data-id="element-344" data-mp="nmnvs9uinm8n">
                    {item.name}
                  </p>
                  <p className="text-[12.5px] font-semibold text-navy/60" data-id="element-345" data-mp="sicygm1u1j96">
                    {item.location} {item.flag}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-346" data-mp="4vegtl1z859o">
          <CtaButton label="Voglio gli stessi risultati" sub="Unisciti a più di 1.000 medici che utilizzano già il sistema" data-id="element-347" data-mp="4ttm9vfnwmbt" />
        </div>
      </div>
    </section>;
}